Postlogin = (function (self) {
    self.UserCCISAssessmentResults = {};
    const me = self.UserCCISAssessmentResults;
    const initGoogleChart = function () {
        // Load the Visualization API and the corechart package.
        google.charts.load('current', { packages: ['corechart'] });

        // Set a callback to run when the Google Visualization API is loaded.
        google.charts.setOnLoadCallback(drawChart);

        // Callback that creates and populates a data table,
        // instantiates the pie chart, passes in the data and draws it.
        function drawChart() {
            const jsonData = $.parseJSON($('#assessment-results-chart').attr('data-json'));
            const data = new google.visualization.DataTable(jsonData);

            const options = {
                pieHole: 0.1,
                backgroundColor: 'transparent',
                is3D: false,
                chartArea: {
                    left: '5%',
                    top: '10%',
                    right: '5%',
                    bottom: '5%',
                    width: '95%',
                    height: '95%',
                },
                // sliceVisibilityThreshold: 0.05
            };

            const view = new google.visualization.DataView(data);
            view.setColumns([0, 2]);

            const chart = new google.visualization.PieChart(document.getElementById('assessment-results-chart'));
            chart.draw(view, options);

            const selectHandler = function () {
                window.location = data.getValue(chart.getSelection()[0].row, 1);
            };

            // Add our selection handler.
            google.visualization.events.addListener(chart, 'select', selectHandler);
        }

        $(window).on('resize', _.debounce(drawChart, 250));
    };

    me.init = function () {
        setTimeout(() => {
            initGoogleChart();
        }, 1);
    };

    return self;
}(Postlogin || {}));
